<template>
  <div class="magnifier-container" ref="container" @mousemove="handleMouseMove" @mouseleave="isZooming = false">
    <!-- 原始图片容器 -->
    <div class="original-image-wrapper" ref="imageWrapper">
      <img 
        :src="src" 
        :style="imgStyle" 
        ref="image" 
        @load="handleImageLoad"
        @mouseenter="isZooming = true"
      >
    </div>
    
    <!-- 放大镜效果 -->
    <div 
      class="zoom-view" 
      v-show="isZooming"
      :style="zoomViewStyle"
    >
      <div 
        class="zoomed-image" 
        :style="zoomedImageStyle"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Magnifier',
  props: {
    src: {
      type: String,
      required: true
    },
    zoomScale: {
      type: Number,
      default: 2
    },
    zoomSize: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      isZooming: false,
      imgWidth: 0,
      imgHeight: 0,
      containerWidth: 0,
      containerHeight: 0,
      mouseX: 0,
      mouseY: 0,
      imgStyle: {
        width: '100%',
        height: 'auto',
        display: 'block'
      }
    }
  },
  computed: {
    zoomViewStyle() {
      return {
        width: `${this.zoomSize}px`,
        height: `${this.zoomSize}px`,
        left: `${this.mouseX - this.zoomSize / 2}px`,
        top: `${this.mouseY - this.zoomSize / 2}px`,
      }
    },
    zoomedImageStyle() {
      // 计算放大区域的位置
      const xRatio = this.mouseX / this.containerWidth
      const yRatio = this.mouseY / this.containerHeight
      
      const bgWidth = this.imgWidth * this.zoomScale
      const bgHeight = this.imgHeight * this.zoomScale
      
      const posX = -xRatio * (bgWidth - this.containerWidth)
      const posY = -yRatio * (bgHeight - this.containerHeight)
      
      return {
        width: `${bgWidth}px`,
        height: `${bgHeight}px`,
        backgroundImage: `url(${this.src})`,
        backgroundSize: `${this.imgWidth}px ${this.imgHeight}px`,
        backgroundRepeat: 'no-repeat',
        transform: `translate(${posX}px, ${posY}px)`
      }
    }
  },
  methods: {
    handleImageLoad() {
      // 获取图片原始尺寸
      const img = this.$refs.image
      this.imgWidth = img.naturalWidth
      this.imgHeight = img.naturalHeight
      
      // 获取容器尺寸
      this.updateContainerSize()
    },
    updateContainerSize() {
      if (this.$refs.container) {
        this.containerWidth = this.$refs.container.offsetWidth
        this.containerHeight = this.$refs.container.offsetHeight
      }
    },
    handleMouseMove(e) {
      if (!this.isZooming) return
      
      // 使用requestAnimationFrame提高性能
      requestAnimationFrame(() => {
        const rect = this.$refs.container.getBoundingClientRect()
        this.mouseX = e.clientX - rect.left
        this.mouseY = e.clientY - rect.top
        
        // 确保放大镜不会超出容器边界
        const halfSize = this.zoomSize / 2
        this.mouseX = Math.max(halfSize, Math.min(this.mouseX, this.containerWidth - halfSize))
        this.mouseY = Math.max(halfSize, Math.min(this.mouseY, this.containerHeight - halfSize))
      })
    },
    handleResize() {
      this.updateContainerSize()
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
    this.updateContainerSize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.magnifier-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.original-image-wrapper {
  width: 100%;
  height: 100%;
}

.zoom-view {
  position: absolute;
  border: 2px solid #fff;
  border-radius: 50%;
  pointer-events: none;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.zoomed-image {
  position: absolute;
  top: 0;
  left: 0;
}
</style>